import { styled } from '@mui/material/styles';

// Tipagem para a prop 'isActive' que o dot receberá
interface DotProps {
  $isActive: boolean;
}

// Tipagem para a prop 'totalWidth' que o wrapper receberá
interface WrapperProps {
  $totalWidth: string;
  $activeIndex: number;
}

// ----------------------------------------------------
// Componente: Container principal do Carrossel (Substitui .carousel-container)
const DOTS_HEIGHT_RESERVATION = '80px'; // Defina o espaço desejado
export const CarouselContainer = styled('div')`
  max-width: 100%; /* Garante que não ultrapasse a tela */
  width: 100%;
  margin: 0 auto; /* Centraliza o carrossel */
  height: 500px; /* Defina uma altura razoável para os cards */
  overflow: hidden;
  position: relative;
  padding-bottom: ${DOTS_HEIGHT_RESERVATION};
`;

// ----------------------------------------------------
// Componente: Container que contém todos os slides lado a lado (Substitui .carousel-slides-wrapper)
// Atualização do SlidesWrapper
// Atualização do SlidesWrapper
export const SlidesWrapper = styled('div')<WrapperProps>`
  display: flex;
  height: 100%;

  /* Mantém a largura total, mas remove o transform */
  /* NOTA: Este valor é calculado no JSX: (numAllSlides * CARD_WIDTH) + (numAllSlides - 1) * 24 */
  width: ${(props) => props.$totalWidth};
  gap: 24px;

  cursor: grab;
`;

// ----------------------------------------------------
// Componente: Estilo individual de ca      n n n    da slide (Substitui .carousel-slide)
export const CarouselSlide = styled('div')`
  flex-shrink: 0;
  width: 320px;
  //height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

// ----------------------------------------------------
// Componente: Container das Bolinhas de controle (Substitui .carousel-dots-container)
export const DotsContainer = styled('div')`
  position: absolute;
  bottom: 20px;
  left: 50%;
  //transform: translateX(-50%);
  display: flex;
  gap: 10px;
  z-index: 10;
`;

// ----------------------------------------------------
// Componente: Estilo da Bolinha individual (Substitui .carousel-dot e .carousel-dot.active)
export const Dot = styled('button')<DotProps>`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${({ $isActive, theme }) =>
    $isActive ? theme.palette.primary['01'] : theme.palette.grey['01']};
  border: 1px solid
    ${({ $isActive, theme }) =>
      $isActive ? theme.palette.primary['01'] : theme.palette.grey['01']};
  cursor: pointer;
  transition:
    background-color 0.3s,
    transform 0.3s;
  padding: 0;

  &:hover {
    background-color: ${({ theme }) => theme.palette.primary['04']};
    border-color: ${({ theme }) => theme.palette.primary['04']};
  }

  /* Aplica estilos condicionais usando a prop $isActive */

  transform: ${(props) => (props.$isActive ? 'scale(1.2)' : '')};
`;
